import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function CustomerForm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('id');
  const isEditMode = !!customerId;
  const [formData, setFormData] = useState({
    name: isEditMode ? 'Acme Corporation' : '',
    email: isEditMode ? 'billing@acme.com' : '',
    phone: isEditMode ? '+66 12 345 6789' : '',
    address: isEditMode ? '123 Business Street' : '',
    city: isEditMode ? 'Bangkok' : '',
    country: isEditMode ? 'Thailand' : 'Thailand',
    status: 'active' as 'active' | 'inactive'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Saving customer:', formData);
    navigate('/customers');
  };
  return <div className="space-y-8 max-w-7xl mx-auto pb-12" data-id="element-7534">
      {/* Header */}
      <div className="flex items-center" data-id="element-7535">
        <button onClick={() => navigate('/customers')} className="flex items-center text-gray-900 hover:text-gray-600 transition-colors text-lg font-semibold" data-id="element-7536">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-7537" />
          {isEditMode ? 'Back to customer' : 'All customers'}
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-7538">
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-7539">
          {/* Basic Information */}
          <div className="p-8 border-b border-gray-100" data-id="element-7540">
            <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-6" data-id="element-7541">
              {isEditMode ? 'Edit Customer' : 'New Customer'}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-7542">
              <div data-id="element-7543">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7544">
                  Customer Name <span className="text-red-500" data-id="element-7545">*</span>
                </label>
                <input type="text" required value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} placeholder="Enter customer name" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors" data-id="element-7546" />
              </div>
              <div data-id="element-7547">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7548">
                  Email <span className="text-red-500" data-id="element-7549">*</span>
                </label>
                <input type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} placeholder="billing@company.com" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors" data-id="element-7550" />
              </div>
              <div data-id="element-7551">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7552">
                  Phone
                </label>
                <input type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} placeholder="+66 12 345 6789" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors" data-id="element-7553" />
              </div>
              <div data-id="element-7554">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7555">
                  Status
                </label>
                <select value={formData.status} onChange={e => setFormData({
                ...formData,
                status: e.target.value as 'active' | 'inactive'
              })} className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors" data-id="element-7556">
                  <option value="active" data-id="element-7557">Active</option>
                  <option value="inactive" data-id="element-7558">Inactive</option>
                </select>
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="p-8" data-id="element-7559">
            <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-6" data-id="element-7560">
              Address
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-7561">
              <div className="md:col-span-2" data-id="element-7562">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7563">
                  Street Address
                </label>
                <input type="text" value={formData.address} onChange={e => setFormData({
                ...formData,
                address: e.target.value
              })} placeholder="123 Business Street" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors" data-id="element-7564" />
              </div>
              <div data-id="element-7565">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7566">
                  City
                </label>
                <input type="text" value={formData.city} onChange={e => setFormData({
                ...formData,
                city: e.target.value
              })} placeholder="Bangkok" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors" data-id="element-7567" />
              </div>
              <div data-id="element-7568">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7569">
                  Country
                </label>
                <input type="text" value={formData.country} onChange={e => setFormData({
                ...formData,
                country: e.target.value
              })} className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors" data-id="element-7570" />
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3" data-id="element-7571">
          <button type="button" onClick={() => navigate('/customers')} className="px-6 py-2.5 bg-white border border-gray-200 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors shadow-sm" data-id="element-7572">
            Cancel
          </button>
          <button type="submit" className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors shadow-sm" data-id="element-7573">
            {isEditMode ? 'Update customer' : 'Create customer'}
          </button>
        </div>
      </form>
    </div>;
}